import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validate that a `FormArray` has a least one item of type string with a length
 * greater than 0.
 */
export const requiredAtLeastOnce = (predicate: (value: unknown) => boolean): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!Array.isArray(control.value)) {
      return {
        requiredAtLeastOnce: true,
      };
    }

    const validValue = control.value.find(predicate);

    return typeof validValue !== 'undefined'
      ? // Return null if validation passes
        null
      : { requiredAtLeastOnce: true };
  };
};
